export const LOGIN = 'LOGIN';
export const LOGOUT = 'LOGOUT';
export const CREATE_ORDER = 'CREATE_ORDER';
export const GET_ALL_ORDERS = 'GET_ALL_ORDERS';
export const GET_ORDER_BY_ID = 'GET_ORDER_BY_ID';
export const CLEAR_ORDER = 'CLEAR_ORDER';

export const RESET_ERROR = 'RESET_ERROR';

export const REQUEST = '_REQUEST';
export const SUCCESS = '_SUCCESS';
export const FAILURE = '_FAILURE';